import { gql } from "@apollo/client";

const getPrivateNotesQuery = gql`
  query getPrivateNotesQuery(
    $profileId: Int!
    $first: Int = 20
    $after: String
  ) {
    user(userId: $profileId) {
      id
      privateNotes(first: $first, after: $after) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            pk
            notes
            created
            creator {
              id
              name
              avatar
            }
          }
        }
      }
    }
  }
`;

export default getPrivateNotesQuery;
